<template>
    <el-dialog
            title="选择文件夹"
            :visible.sync="openDialogVisiable"
            width="35%"
            top="13%"
            custom-class="customer-dialog"
            :before-close="closeDialog">
      <div :style="{height: (computedHeight-500)+'px'}" class="dialog-body">
        <div>
          <el-tree v-if="showTree"
            ref="dirTree"
            @node-click="onClickNode"
            :highlight-current="true"
            :props="props"
            :load="loadNode"
            lazy
            @check-change="handleCheckChange">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span style="margin:5px;">
                <i class="el-icon-cus-folder1" style="margin-right:10px;color: rgb(255, 225, 123);"></i>{{node.label}}
              </span>
            </span>
          </el-tree>
        </div>
      </div>
        <span slot="footer" class="dialog-footer">
    <el-button size="mini" @click="closeDialog">取 消</el-button>
    <el-button size="mini" type="primary" @click="clickConfirm">确 定</el-button>
  </span>
    </el-dialog>
</template>

<script>
import {mapState, mapMutations} from 'vuex'
import ct from '../../utils/constant.js'
export default {
  props: ['openDialogVisiable', 'checkRowList', 'fileRouterList'],
  data () {
    return {
      props: {
        label: 'dirName',
        children: 'subDir',
        isLeaf: 'leaf'
      },
      count: 1,
      dirFileGuid: '',
      currentNodeData: null,
      showTree: false
    }
  },
  watch: {
    'checkRowList': {
      handler: function (val) {
        this.showTree = true
        /**
         *  let tree = this.$refs.dirTree
         if (tree) {
          tree.$data.store.lazy = true
        }
         */
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations(['setFilesList']),
    closeDialog () {
      this.showTree = false
      // this.$refs.dirTree.$data.store.lazy = false
      this.$emit('closeDialog')
      this.$emit('clearCheckRowList')
    },
    handleCheckChange (data, checked, indeterminate) {
      // console.log(data, checked, indeterminate)
    },
    loadNode (node, resolve) {
      // console.log('loadNode', node)
      if (node.level === 0) {
        // this.cusDirFile.fileGuid
        let guid = this.rootFile.fileGuid
        if (this.canUploadCommon) {
          guid = this.genechemFile.fileGuid
        }
        return this.loadNodeHandler(guid, resolve)
      } else {
        return this.loadNodeHandler(node.data.dirGUID, resolve)
      }
    },
    loadNodeHandler (fileGuid, resolve) {
      let list = []
      return this.getNodeData(fileGuid, res => {
        res.forEach(el => {
          if (!el.hasSubDir) {
            el.leaf = true // 叶子节点
          }
          // console.log('loadNodeHandler')
          list.push(el)
        })
        return resolve(list)
      })
    },
    getNodeData (fileGuid, calback) {
      this.postRequest('listDirSubFiles', fileGuid).then(res => {
        let result = res.data.result
        calback && calback(result)
      })
    },
    onClickNode (data, node) {
      this.currentNodeData = data
    },
    clickConfirm () {
      let node = this.currentNodeData
      if (node === null) {
        this.$message({message: '请选择文件夹', type: 'error'})
        return
      }
      let param = {}
      param.targetDir = node.dirGUID
      param.fileGuids = this.getFileGuids()
      this.postRequest('moveFiles', param).then(res => {
        if (res && res.data.code === 0) {
          this.closeDialog()
          let list = this.filesList
          for (let i = 0; i < this.checkRowList.length; i++) {
            let check = this.checkRowList[i]
            for (let j = 0; j < list.length; j++) {
              let all = list[j]
              if (all.fileGuid === check.fileGuid) {
                list.splice(j, 1)
              }
            }
          }
          this.setFilesList(list)
          this.$emit('deleteCheckRow')
          this.$message({message: '操作成功～', type: 'success'})
        }
      })
    },
    getFileGuids () {
      let fileGuids = []
      this.checkRowList.forEach(f => {
        fileGuids.push(f.fileGuid)
      })
      return fileGuids
    }
  },
  computed: {
    ...mapState(['computedHeight', 'cusDirFile', 'rootFile', 'filesList', 'isCloudAdmin', 'genechemFile', 'isCommonFileAdmin']),
    canUploadCommon () {
      console.log('canUploadCommon')
      return this.fileRouterList.length > 1 && this.fileRouterList[1].category === ct.FileType.common && (this.isCloudAdmin === ct.Boolean.yes || this.isCommonFileAdmin === ct.Boolean.yes)
    }
  }
}
</script>
<style>
  .dialog-body {
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/MoveToDir.vue